import React from "react";
import { VBox } from "../box/Box";
import Pre from "../pre/Pre";
import { Typo } from "../text/Typo";

export const TitledValue = ({
	title,
	value,
	valueColor,
	variant,
	color,
}: {
	title: string;
	value: any;
	valueColor?: string;
	variant?: "modern";
	color?: string;
}) => {
	if (!title) title = "---";
	if (title === "ctime") title = "created at";

	let valueAsObject = false;
	if (typeof value === "object") {
		valueAsObject = true;
		if (!React.isValidElement(value)) {
			try {
				value = <Pre data={JSON.stringify(value, null, 2)} wrap label={title} />;
			} catch (e) {
				value = "Unparseable object";
			}
		}
	}

	title = title[0].toUpperCase() + title.slice(1);
	title = title.split("_").join(" ");

	if (!valueAsObject) {
		if (isNaN(value) && !value) value = "";
		if (value === null) value = "---";
		value = value + "";

		value = value.split("_").join(" ");

		if (
			value &&
			typeof value === "string" &&
			value.indexOf("Z") !== -1 &&
			value.indexOf("T") !== -1 &&
			value.indexOf(":") !== -1 &&
			value.indexOf("-") !== -1
		) {
			try {
				const dta = new Date(value);
				value = dta.toLocaleDateString() + ", " + dta.toLocaleTimeString();
			} catch (e) {}
		}
	}

	return (
		<VBox
			sx={{
				backgroundColor: color ?? "transparent",
				gap: "2px",
				overflow: "hidden",
				padding: variant === "modern" ? "10px" : undefined,
				borderRadius: variant === "modern" ? "6px" : undefined,
				borderBottom: variant === "modern" ? "1px solid rgba(0,0,0,.1)" : "unset",
			}}>
			<Typo variant={variant === "modern" ? "caption" : "small"} sx={{ color: undefined, textTransform: variant === "modern" ? "uppercase" : undefined }}>
				{title}:
			</Typo>
			<Typo
				variant="medium"
				sx={{
					color: valueColor ?? undefined,
					display: "block",
					textOverflow: "ellipsis",
				}}>
				{value}
			</Typo>
		</VBox>
	);
};
